import { render, staticRenderFns } from "./SectionError.vue?vue&type=template&id=c3a0ad64&scoped=true&"
import script from "./SectionError.vue?vue&type=script&lang=js&"
export * from "./SectionError.vue?vue&type=script&lang=js&"
import style0 from "./SectionError.vue?vue&type=style&index=0&id=c3a0ad64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a0ad64",
  null
  
)

export default component.exports